
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-ab7239d0\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./authentication.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./authentication.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ab7239d0\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./authentication.vue.html"),
  /* scopeId */
  "data-v-ab7239d0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/authentication/authentication.vue.html
// module id = ASit
// module chunks = 2